export default __webpack_public_path__ + "static/media/1235.74b852e7.png";